module.exports = __webpack_public_path__ + "static/media/cuidadoDomiciliario.620c042e.png";